
async function delay (milli) {
    return new Promise (async (resolve) => {
        setTimeout(() => {
            resolve();
        }, milli);
    });
}

export default delay;